import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2 } from "lucide-react";

export default function AdminCenterPage({
  newCenterData,
  setNewCenterData,
  handleCreateCenter,
  centersList,
}) {
  return (
    <Card className="shadow-lg">
      <CardHeader className="border-b">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Building2 className="w-5 h-5 text-emerald-600" />
          Center Management
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-4 space-y-4">
        <form onSubmit={handleCreateCenter} className="space-y-3">
          <div className="space-y-2">
            <Label htmlFor="center-name">Center Name</Label>
            <Input
              id="center-name"
              value={newCenterData.name}
              onChange={(event) => setNewCenterData({ ...newCenterData, name: event.target.value })}
              placeholder="Munich Center"
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="center-location">Location</Label>
            <Input
              id="center-location"
              value={newCenterData.location}
              onChange={(event) => setNewCenterData({ ...newCenterData, location: event.target.value })}
              placeholder="Munich"
            />
          </div>
          <Button type="submit" className="w-full bg-emerald-600 hover:bg-emerald-700">
            Create Center
          </Button>
        </form>

        <div className="space-y-2 max-h-80 overflow-y-auto">
          {centersList.length === 0 ? (
            <p className="text-sm text-slate-500">No centers created yet.</p>
          ) : (
            centersList.map((center) => (
              <div key={center.id} className="rounded-lg border border-slate-200 p-3 bg-slate-50">
                <p className="font-medium text-slate-900">{center.name}</p>
                <p className="text-sm text-slate-500">{center.location || "Location not set"}</p>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
}